import { render, staticRenderFns } from "./TeachersAppraisal.vue?vue&type=template&id=68e227c2&scoped=true&"
import script from "./TeachersAppraisal.vue?vue&type=script&lang=js&"
export * from "./TeachersAppraisal.vue?vue&type=script&lang=js&"
import style0 from "./TeachersAppraisal.vue?vue&type=style&index=0&id=68e227c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e227c2",
  null
  
)

export default component.exports